import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AnswerKeyComponent } from './components/answer-key/answer-key.component';
import { AssignTestComponent } from './components/assign-test/assign-test.component';
import { BatchComponent } from './components/batch/batch.component';
import { CompletedTestComponent } from './components/completed-test/completed-test.component';
import { ClassesComponent } from './components/classes/classes.component';
import { CreateQuestionComponent } from './components/create-question/create-question.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { NewDashboardComponent } from './components/new-dashboard/new-dashboard.component';
import { ListOfTestsComponent } from './components/list-of-tests/list-of-tests.component';
import { LoginComponent } from './components/login/login.component';
import { ManageCourseMaterialContainerComponent } from './components/manage-course-material-container/manage-course-material-container.component';
import { MathjaxTestComponent } from './components/mathjax-test/mathjax-test.component';
import { NewLandingPageComponent } from './components/new-landing-page/new-landing-page.component';
import { NotesComponent } from './components/notes/notes.component';
import { PaymentComponent } from './components/payment/payment.component';
import { QuestionBankComponent } from './components/question-bank/question-bank.component';
import { ReportComponent } from './components/report/report.component';
import { ScoreAnalysisComponent } from './components/score-analysis/score-analysis.component';
import { StudentClassesComponent } from './components/student-classes/student-classes.component';
import { StudentCreationComponent } from './components/student-creation/student-creation.component';
import { StudentMaterialComponent } from './components/student-material/student-material.component';
import { TopicComponent } from './components/topic/topic.component';
import { NotificationComponent } from './components/notification/notification.component';
import { OnlineTestComponent } from './components/online-test/online-test.component';
import { TermsComponent } from './components/terms/terms.component';
import { UserDetailsComponent } from './components/user-details/user-details.component';
import { UserProfileComponent } from './components/user-profile/user-profile.component';
import {
  AdminGuard,
  AdminOrTutorGuard,
  AuthGuard,
  NonRoleSelectGuard,
  RoleSelectGuard,
  StudentGuard,
  UnAuthGuard,
  UserGuard
} from './services/auth.guard';
import { ViewResultsComponent } from './components/view-results/view-results.component';
import { QandaComponent } from './components/qanda/qanda.component';
import { UsersComponent } from './components/users/users.component';
import { CreateModuleComponent } from './components/create-module/create-module.component';
import { ClassesCalendarComponent } from './components/classes-calendar/classes-calendar.component';
import { TestCreationComponent } from './components/test-creation/test-creation.component';
import { PracticeTestComponent } from './components/practice-test/practice-test.component';
import { AcademicCoachingComponent } from './components/academic-coaching/academic-coaching.component';
import { PaymentsManagerComponent } from './components/payment-manager/payments-manager.component';
import { StudentPaymentComponent } from './components/student-payment/student-payment.component';
import { TestScoringPatternComponent } from './components/test-creation/scoring/test-scoring-pattern/test-scoring-pattern.component';
import { PrintTestComponent } from './components/print-test/print-test.component';
import { SignInComponent } from './components/sign-in/sign-in.component';
import { BuySuccessComponent } from './modules/package/buy-success/buy-success.component';
import { ChartComponent } from './components/chart/chart.component';
import { MathjaxEditorComponent } from './modules/commonly-used/mathjax-editor/mathjax-editor.component';
import { UnsavedChangesGuard } from './services/unsaved-changes.guard';
import { ManageClassesComponent } from './components/manage-classes/manage-classes.component';

const routes: Routes = [
  {
    path: '',
    // canActivate: [UnAuthGuard],
    // component: NewLandingPageComponent,
    redirectTo: '/login',
    pathMatch: 'full'
  },
  {
    path: 'dashboard',
    canActivate: [AuthGuard, RoleSelectGuard, AdminOrTutorGuard],
    component: DashboardComponent
  },
  // new dashboard route
  {
    path: 'new-dashboard',
    canActivate: [AuthGuard, RoleSelectGuard],
    component: NewDashboardComponent
  },
  {
    path: 'login',
    canActivate: [UnAuthGuard],
    component: LoginComponent
  },
  {
    path: 'register',
    canActivate: [UnAuthGuard],
    component: LoginComponent
  },
  {
    path: 'online-test/:studentTestId',
    canActivate: [AuthGuard, RoleSelectGuard],
    component: OnlineTestComponent
  },
  {
    path: 'notification',
    canActivate: [AuthGuard, RoleSelectGuard, AdminOrTutorGuard],
    component: NotificationComponent
  },
  {
    path: 'terms',
    component: TermsComponent
  },
  {
    path: 'classes',
    canActivate: [AuthGuard, RoleSelectGuard, AdminOrTutorGuard],
    component: ClassesComponent
  },
  // {
  //   path: 'mathjax-test',
  //   canActivate: [AuthGuard],
  //   component: MathjaxTestComponent,
  // },
  {
    path: 'role-select',
    canActivate: [AuthGuard, NonRoleSelectGuard],
    component: UserProfileComponent
  },
  {
    path: 'profile',
    canActivate: [AuthGuard, RoleSelectGuard, UserGuard],
    component: UserProfileComponent
  },
  {
    path: 'user-details/:userId',
    canActivate: [AuthGuard, RoleSelectGuard, AdminGuard],
    component: UserDetailsComponent
  },
  {
    path: 'question-bank',
    canActivate: [AuthGuard, RoleSelectGuard, AdminOrTutorGuard],
    component: QuestionBankComponent
  },
  {
    path: 'create-question',
    canActivate: [AuthGuard, RoleSelectGuard, AdminOrTutorGuard],
    component: CreateQuestionComponent
  },
  {
    path: 'create-learning-module',
    canActivate: [AuthGuard, RoleSelectGuard, AdminOrTutorGuard],
    component: CreateModuleComponent
  },
  {
    path: 'edit-question',
    canActivate: [AuthGuard, RoleSelectGuard, AdminOrTutorGuard],
    component: CreateQuestionComponent
  },
  {
    path: 'manage-course-material',
    canActivate: [AuthGuard, RoleSelectGuard, AdminOrTutorGuard],
    component: ManageCourseMaterialContainerComponent
  },
  {
    path: 'my-material',
    canActivate: [AuthGuard, RoleSelectGuard, StudentGuard],
    component: StudentMaterialComponent
  },
  {
    path: 'schedules',
    canActivate: [AuthGuard, RoleSelectGuard],
    component: ClassesCalendarComponent
  },
  // {
  //   path: 'view-classes',
  //   canActivate: [AuthGuard, RoleSelectGuard],
  //   component: StudentClassesComponent,
  // },
  {
    path: 'practice-test',
    canActivate: [AuthGuard, RoleSelectGuard],
    component: PracticeTestComponent
  },
  {
    path: 'view-results',
    canActivate: [AuthGuard, RoleSelectGuard],
    component: ViewResultsComponent
  },
  {
    path: 'list-of-tests',
    canActivate: [AuthGuard, RoleSelectGuard],
    component: ListOfTestsComponent
  },
  {
    path: 'tests',
    canActivate: [AuthGuard, RoleSelectGuard, AdminOrTutorGuard],
    component: QandaComponent
  },
  {
    path: 'question-bank-ai',
    canActivate: [AuthGuard, RoleSelectGuard, AdminOrTutorGuard],
    loadChildren: () =>
      import('./modules/question-bank-ai/question-bank-ai.module').then(
        (m) => m.QuestionBankAiModule
      ),
  },
  {
    path: 'workshops',
    canActivate: [AuthGuard, RoleSelectGuard],
    loadChildren: () =>
      import('./modules/workshop/workshop.module').then((m) => m.WorkshopModule)
  },
  // ** test-creation route
  {
    path: 'test-creation',
    canActivate: [AuthGuard, RoleSelectGuard],
    component: TestCreationComponent
  },
  {
    path: 'test-creation/:testId',
    canActivate: [AuthGuard, RoleSelectGuard],
    component: TestCreationComponent
  },
  {
    path: 'test-creation/:testId/scoring-pattern',
    canActivate: [AuthGuard, RoleSelectGuard],
    component: TestScoringPatternComponent
  },
  {
    path: 'print-test/:testTypeId/:testId',
    canActivate: [AuthGuard, RoleSelectGuard, AdminOrTutorGuard],
    component: PrintTestComponent
  },
  {
    path: 'academic-coaching',
    canActivate: [AuthGuard, RoleSelectGuard],
    component: AcademicCoachingComponent
  },
  {
    path: 'topic',
    canActivate: [AuthGuard, RoleSelectGuard, AdminOrTutorGuard],
    component: TopicComponent
  },
  {
    path: 'answer-key/:testId',
    canActivate: [AuthGuard, RoleSelectGuard, AdminOrTutorGuard],
    component: AnswerKeyComponent
  },
  {
    path: 'notes',
    canActivate: [AuthGuard, RoleSelectGuard, AdminGuard],
    component: NotesComponent
  },
  {
    path: 'payments',
    canActivate: [AuthGuard, RoleSelectGuard, AdminGuard],
    component: PaymentComponent
  },
  {
    path: 'student-payments',
    canActivate: [],
    component: StudentPaymentComponent
  },
  {
    path: 'payments-manager',
    canActivate: [AuthGuard, RoleSelectGuard, AdminGuard],
    component: PaymentsManagerComponent
  },
  {
    path: 'assign-test/:testId',
    canActivate: [AuthGuard, RoleSelectGuard, AdminOrTutorGuard],
    component: AssignTestComponent
  },
  {
    path: 'score-analysis/:testId',
    canActivate: [AuthGuard, RoleSelectGuard, AdminGuard],
    component: ScoreAnalysisComponent
  },
  {
    path: 'analyze-test/:testId',
    canActivate: [AuthGuard, RoleSelectGuard, AdminGuard],
    component: CompletedTestComponent
  },
  {
    path: 'report/:studentTestId',
    canActivate: [AuthGuard, RoleSelectGuard],
    component: ReportComponent
  },
  {
    path: 'create-student',
    canActivate: [AuthGuard, RoleSelectGuard, AdminGuard],
    component: StudentCreationComponent
  },
  {
    path: 'create-batch',
    canActivate: [AuthGuard, RoleSelectGuard, AdminOrTutorGuard],
    component: BatchComponent
  },
  {
    path: 'edit-batch/:batchId',
    canActivate: [AuthGuard, RoleSelectGuard, AdminOrTutorGuard],
    component: BatchComponent
  },
  {
    path: 'learning-modules',
    loadChildren: () =>
      import('./modules/learning-modules/learning-modules.module').then(
        (m) => m.LearningModulesModule
      )
  },
  {
    path: 'users',
    canActivate: [AuthGuard, RoleSelectGuard, AdminGuard],
    component: UsersComponent
  },
  // {
  //   path: 'student-learning',
  //   loadChildren: () =>
  //     import('./modules/student-learning/student-learning.module').then(
  //       (m) => m.StudentLearningModule
  //     ),
  // },
  {
    path: 'student-learning',
    loadChildren: () =>
      import('./modules/new-student-learning/student-learning.module').then(
        (m) => m.StudentLearningModule
      )
  },
  {
    path: 'student-test/:testId',
    loadChildren: () =>
      import('./modules/student-test/student-test.module').then(
        (m) => m.StudentTestModule
      ),
    canActivate: [AuthGuard, RoleSelectGuard, StudentGuard]
  },
  {
    path: 'packages',
    loadChildren: () =>
      import('./modules/package/package.module').then((m) => m.PackageModule)
  },
  {
    path: 'error',
    component: LoginComponent
  },
  {
    path: 'sign-in',
    component: SignInComponent
  },
  {
    path: 'package-payments',
    component: BuySuccessComponent
  },
  {
    path: 'chart',
    component: ChartComponent,
    canActivate: [AuthGuard, StudentGuard]
  },
  {
    path: 'stripe-payment',
    loadChildren: () =>
      import('./modules/stripe-payment/stripe-payment.module').then(
        (m) => m.StripePaymentModule
      )
  },
  {
    path: 'manage-assignment',
    loadChildren: () =>
      import('./modules/manage-assignments/manage-assignments.module').then(
        (m) => m.ManageAssignmentsModule
      ),
    canActivate: [AuthGuard, AdminOrTutorGuard]
  },

  {
    path: 'student-progress',
    loadChildren: () =>
      import('./modules/student-progress/student-progress.module').then(
        (m) => m.StudentProgressModule
      ),
    canActivate: [AuthGuard, AdminOrTutorGuard]
  },
   {
    path: 'create-class',
    component: ManageClassesComponent,
    canActivate: [AuthGuard, AdminOrTutorGuard],
    canDeactivate: [UnsavedChangesGuard]
  },
  {
    path: 'edit-class/:batchId',
    component: ManageClassesComponent,
    canActivate: [AuthGuard, AdminOrTutorGuard],
    canDeactivate: [UnsavedChangesGuard]
  },
  {
    path: 'generate-ai-questions',
    loadChildren: () =>
      import(
        './modules/generate-ai-questions/generate-ai-questions.module'
      ).then((m) => m.GenerateAiQuestionsModule),
    canActivate: [AuthGuard, AdminOrTutorGuard],
  },
  {
    path: 'mathjax-edit',
    component: MathjaxEditorComponent
  },
  {
    path: '**',
    redirectTo: '#/'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule {}
